import { Link } from 'react-router';
import { paths } from '@/routing';
import { JobsIndicator } from './JobsIndicator';
import { Logo } from './Logo';
import { ProjectSwitcher } from './ProjectSwitcher';
import { UploadIndicator } from './UploadIndicator';
import { UserMenu } from './UserMenu';
import styles from './TopBar.module.css';

export function TopBar() {
  return (
    <header className={styles.bar}>
      <Link to={paths.home()} className={styles.brand} aria-label="HSI Label — all projects">
        <Logo />
      </Link>
      <span className={styles.divider} aria-hidden>
        /
      </span>
      <ProjectSwitcher />
      <div className="spacer" />
      <UploadIndicator />
      <JobsIndicator />
      <UserMenu />
    </header>
  );
}
